const PRINT_TRANS = {
  'ELECTRONIC TICKET': 'ელექტრონული ბილეთი',
  'ISSUING OFFICE': 'ბილეთის გამომწერი',
  'Vanilla Sky Georgia': 'ვანილა სქაი ჯორჯია',
  'ISSUING DATE': 'გამოწერის თარიღი',
  'ONE WAY/RETURN': 'ერთიმხარე/ორიმხარე',
  'NAME': 'გვარი/სახელი',
  'AIRLINE': 'ავიაკომპანია',
  'AK Air Georgia': 'აკ ეარ ჯორჯია',
  'TICKET NUMBER': 'ბილეთის ნომერი',
  'TICKET PRICE': 'ბილეთის საფასური',
  'GEL': 'ლარი',
  'Registration Time': 'რეგისტრაციის დრო',
  'FROM': 'საიდან',
  'TO': 'სად',
  'DATE DEPARTURE': 'თარიღი გაფრენა',
  'TIME': 'დრო',
  'DATE ARRIVAL': 'თარიღი ჩაფრენა'
};

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'printTrans'
})
export class PrintTransPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!args) {
      return PRINT_TRANS[value];
    } else {
      return value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/print-trans.pipe.ts